export default __webpack_public_path__ + "static/media/mongo.38dd9147.png";